export default ({
  data: { success, updatedAt }
}) => {
  if (!success) return {editorHeaderStatus: 'error'};

  return {
    editorHeaderStatus: 'saved',
    editorHeaderUpdatedAt: updatedAt,
    editorIsDraft: true
  }; 
};
